export default "__VITE_ASSET__925d24b4__"